<template>
  <section class="other-links">
    <h3 v-if="links.length " class="other-links__title">
      <font-awesome-icon :icon="['fas', 'link']" class="map__icon" />
      {{isFestivalYear ? '相關網站' : '相關連結'}}
    </h3>
    <section class="flex-container">
      <div v-for="(link, index) in links" :key="index" class="other-link">
        <a
          v-if="titleImage.target === 'blank'"
          :href="link.url"
          target="_blank"
          class="other-link__link"
          :title="`[另開新分頁]前往${link.name}`"
          >{{ link.name }}</a
        >
        <a
          v-else
          :href="`/${titleImage.category}/${link.reference}`"
          class="other-link__link"
          >{{ link.name }}</a
        >
      </div>
    </section>
  </section>
</template>

<script>
export default {
  name: 'ArticleOtherLinks',
  props: {
    links: {
      type: Array,
      default: () => [],
    },
    titleImage: {
      type: Object,
      default: () => {
        return { src: '123.png', alt: 'åœ–é‘‘é›†' };
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.other-links {
  /* margin: 0 10px 30px; */
  @include article-content-spacing(mobile);

  @include for-tablet {
    /* @include article-content-spacing(tablet); */
  }

  @include for-desktop {
    /* @include article-content-spacing(desktop); */
  }

  &__title {
    font-size: 1rem !important;
    text-align: left !important;
    margin-bottom: 0 !important;
    font-weight: 600;
    padding: 10px 0;
    color: $color-light-text;
  }

  > h3 {
    margin-top: 0;
    margin-bottom: 1rem;
    text-align: center;
  }

  a {
    color: $color-light-text;
  }
}

.other-link {
  text-decoration: underline;
}

.other-link + .other-link {
  margin-top: 10px;
}
</style>
